import {
  UPDATE_CONTRACT_DETAIL,
  CONTRACT_GET_ELIGIBILITY_ERROR,
  CONTRACT_GET_ELIGIBILITY_REQUEST,
  CONTRACT_GET_ELIGIBILITY_SUCCESS,
  CONTRACT_GET_EXISTINGVAS_ERROR,
  CONTRACT_GET_EXISTINGVAS_REQUEST,
  CONTRACT_GET_EXISTINGVAS_SUCCESS,
  CONTRACT_GET_PRICE_PLANS_ERROR,
  CONTRACT_GET_PRICE_PLANS_REQUEST,
  CONTRACT_GET_PRICE_PLANS_SUCCESS,
  CONTRACT_GET_SERVICE_NUMBERS_ERROR,
  CONTRACT_GET_SERVICE_NUMBERS_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_SUCCESS,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_SUCCESS,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_ERROR,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_SUCCESS,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_ERROR,
  FILTER_BY_EXPIRY_REQUEST,
  FILTER_BY_EXPIRY_SUCCESS,
  FILTER_BY_EXPIRY_ERROR,
  ADDONS_EXISTINGVAS_REQUEST,
  ADDONS_EXISTINGVAS_SUCCESS,
  ADDONS_EXISTINGVAS_ERROR,
  CONTACT_EXPIRY_REQUEST,
  CONTACT_EXPIRY_SUCCESS,
  CONTACT_EXPIRY_ERROR,
  FILTER_BY_SIM_REQUEST,
  FILTER_BY_SIM_SUCCESS,
  FILTER_BY_SIM_ERROR,
  ACTIVATE_SIM_REQUEST,
  ACTIVATE_SIM_ERROR,
  ACTIVATE_SIM_SUCCESS,
  CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_ERROR,
  CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_SUCCESS,
  CEASE_ADDONS_GET_SERVICE_NUMBERS_REQUEST,
  CEASE_ADDONS_GET_SERVICE_NUMBERS_SUCCESS,
  CEASE_ADDONS_GET_SERVICE_NUMBERS_ERROR,
  CEASE_ADDONS_DETAILS_REQUEST,
  CEASE_ADDONS_DETAILS_SUCCESS,
  CEASE_ADDONS_DETAILS_FAILURE,
  SUSPEND_LINE_GET_SERVICE_NUMBERS_REQUEST,
  SUSPEND_LINE_GET_SERVICE_NUMBERS_SUCCESS,
  SUSPEND_LINE_GET_SERVICE_NUMBERS_FAILURE,
  REFIT_LINE_SERVICE_NUMBERS_REQUEST,
  REFIT_LINE_SERVICE_NUMBERS_SUCCESS,
  REFIT_LINE_SERVICE_NUMBERS_ERROR,
  SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_FAILURE,
  SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_REQUEST,
  SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_SUCCESS
} from './actionTypes';

import {
  ContractServiceNumbersRequest,
  ContractServiceNumbersSuccess,
  ContractServiceNumbersFailure,
  ContractServiceNumbersForTerminateNumberRequest,
  ContractServiceNumbersForTerminateNumberSuccess,
  ContractServiceNumbersForTerminateNumberFailure,
  ContractServiceNumbersForChangePlanRequest,
  ContractServiceNumbersForChangePlanSuccess,
  ContractServiceNumbersForChangePlanFailure,
  ContractPricePlansRequest,
  ContractPricePlansSuccess,
  ContractPricePlansFailure,
  RecontractEligibilityValuesRequest,
  RecontractEligibilityValuesSuccess,
  RecontractEligibilityValuesFailure,
  ExistingAddOnsValuesRequest,
  ExistingAddOnsValuesSuccess,
  ExistingAddOnsValuesFailure,
  ExistingVasFailure,
  ExistingVasRequest,
  ExistingVasSuccess,
  ContactExpiryValuesRequest,
  ContactExpiryValuesSuccess,
  ContactExpiryValuesFailure,
  FilterByExpiryRequest,
  FilterByExpirySuccess,
  FilterByExpiryFailure,
  FilterBySIMRequest,
  FilterBySIMSuccess,
  FilterBySIMFailure,
  ActivateSIMSuccess,
  ActivateSIMRequest,
  ContractServiceNumbersWithNTFailure,
  ContractServiceNumbersWithNTRequest,
  ContractServiceNumbersWithNTSuccess,
  ICeaseAddonsServiceNumbers,
  RefitLineServiceNoRequest,
  RefitLineServiceNoSuccess,
  RefitLineServiceNoFailure,
  IUnsuspendServiceNumbers
} from './models/types';

export const updateContractDetail = {
  request: (detail) => ({
    type: UPDATE_CONTRACT_DETAIL,
    detail
  })
};

export const getContractServiceNumbers = {
  request: (reqData): ContractServiceNumbersRequest => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_REQUEST,
    reqData
  }),
  success: (data): ContractServiceNumbersSuccess => ({ type: CONTRACT_GET_SERVICE_NUMBERS_SUCCESS, data }),
  failure: (error): ContractServiceNumbersFailure => ({ type: CONTRACT_GET_SERVICE_NUMBERS_ERROR, error })
};

export const getContractServiceNumbersForTerminateNumber = {
  request: (reqData): ContractServiceNumbersForTerminateNumberRequest => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_REQUEST,
    reqData
  }),
  success: (data): ContractServiceNumbersForTerminateNumberSuccess => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_SUCCESS,
    data
  }),
  failure: (error): ContractServiceNumbersForTerminateNumberFailure => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_ERROR,
    error
  })
};

export const getContractServiceNumbersForChangePlan = {
  request: (reqData): ContractServiceNumbersForChangePlanRequest => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_REQUEST,
    reqData
  }),
  success: (data): ContractServiceNumbersForChangePlanSuccess => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_SUCCESS,
    data
  }),
  failure: (error): ContractServiceNumbersForChangePlanFailure => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_ERROR,
    error
  })
};

export const getContractPricePlans = {
  request: (): ContractPricePlansRequest => ({ type: CONTRACT_GET_PRICE_PLANS_REQUEST }),
  success: (data): ContractPricePlansSuccess => ({ type: CONTRACT_GET_PRICE_PLANS_SUCCESS, data }),
  failure: (error): ContractPricePlansFailure => ({ type: CONTRACT_GET_PRICE_PLANS_ERROR, error })
};

export const getRecontractEligibilityValues = {
  request: (): RecontractEligibilityValuesRequest => ({ type: CONTRACT_GET_ELIGIBILITY_REQUEST }),
  success: (data): RecontractEligibilityValuesSuccess => ({ type: CONTRACT_GET_ELIGIBILITY_SUCCESS, data }),
  failure: (error): RecontractEligibilityValuesFailure => ({ type: CONTRACT_GET_ELIGIBILITY_ERROR, error })
};

export const getExistingVas = {
  request: (callback: ((data: any) => void) | null = () => { }): ExistingVasRequest => ({
    type: CONTRACT_GET_EXISTINGVAS_REQUEST,
    callback
  }),
  success: (data): ExistingVasSuccess => ({ type: CONTRACT_GET_EXISTINGVAS_SUCCESS, data }),
  failure: (error): ExistingVasFailure => ({ type: CONTRACT_GET_EXISTINGVAS_ERROR, error })
};

export const getFilterByExpiry = {
  request: (): FilterByExpiryRequest => ({ type: FILTER_BY_EXPIRY_REQUEST }),
  success: (data): FilterByExpirySuccess => ({ type: FILTER_BY_EXPIRY_SUCCESS, data }),
  failure: (error): FilterByExpiryFailure => ({ type: FILTER_BY_EXPIRY_ERROR, error })
};

export const getAddOnsExistingVasValues = {
  request: (): ExistingAddOnsValuesRequest => ({ type: ADDONS_EXISTINGVAS_REQUEST }),
  success: (data): ExistingAddOnsValuesSuccess => ({ type: ADDONS_EXISTINGVAS_SUCCESS, data }),
  failure: (error): ExistingAddOnsValuesFailure => ({ type: ADDONS_EXISTINGVAS_ERROR, error })
};

export const getContactExpiry = {
  request: (): ContactExpiryValuesRequest => ({ type: CONTACT_EXPIRY_REQUEST }),
  success: (data): ContactExpiryValuesSuccess => ({ type: CONTACT_EXPIRY_SUCCESS, data }),
  failure: (error): ContactExpiryValuesFailure => ({ type: CONTACT_EXPIRY_ERROR, error })
};

export const getFilterBySIM = {
  request: (): FilterBySIMRequest => ({ type: FILTER_BY_SIM_REQUEST }),
  success: (data): FilterBySIMSuccess => ({ type: FILTER_BY_SIM_SUCCESS, data }),
  failure: (error): FilterBySIMFailure => ({ type: FILTER_BY_SIM_ERROR, error })
};

export const getActivatedSIM = {
  request: (reqData): ActivateSIMRequest => ({
    type: ACTIVATE_SIM_REQUEST,
    reqData
  }),
  success: (data): ActivateSIMSuccess => ({ type: ACTIVATE_SIM_SUCCESS, data }),
  failure: (error): ContractServiceNumbersFailure => ({ type: ACTIVATE_SIM_ERROR, error })
};

export const getContractServiceNumbersWithNT = {
  request: (reqData): ContractServiceNumbersWithNTRequest => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_REQUEST,
    reqData
  }),
  success: (data): ContractServiceNumbersWithNTSuccess => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_SUCCESS,
    data
  }),
  failure: (error): ContractServiceNumbersWithNTFailure => ({
    type: CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_ERROR,
    error
  })
};

export const getCeaseAddonsServiceNumbers = {
  request: (reqData: ICeaseAddonsServiceNumbers) => ({
    type: CEASE_ADDONS_GET_SERVICE_NUMBERS_REQUEST,
    reqData
  }),
  success: (data) => ({
    type: CEASE_ADDONS_GET_SERVICE_NUMBERS_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: CEASE_ADDONS_GET_SERVICE_NUMBERS_ERROR,
    error
  })
};

export const getCeaseAddonsDetails = {
  request: (reqData) => ({
    type: CEASE_ADDONS_DETAILS_REQUEST,
    reqData
  }),
  success: (data) => ({
    type: CEASE_ADDONS_DETAILS_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: CEASE_ADDONS_DETAILS_FAILURE,
    error
  })
};


export const getSuspendUnsuspendLineServiceNumbers = {
  request: (reqData: IUnsuspendServiceNumbers) => ({
    type: SUSPEND_LINE_GET_SERVICE_NUMBERS_REQUEST,
    reqData
  }),
  success: (data) => ({
    type: SUSPEND_LINE_GET_SERVICE_NUMBERS_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: SUSPEND_LINE_GET_SERVICE_NUMBERS_FAILURE,
    error
  })
};

export const getSuspendLineEligibilty = {
  request: (reqData, callback) => ({
    type: SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_REQUEST,
    reqData,
    callback
  }),
  success: (data) => ({
    type: SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_FAILURE,
    error
  })
};

export const refitServiceNumber = {
  request: (reqData): RefitLineServiceNoRequest => ({
    type: REFIT_LINE_SERVICE_NUMBERS_REQUEST,
    reqData
  }),
  success: (data): RefitLineServiceNoSuccess => ({
    type: REFIT_LINE_SERVICE_NUMBERS_SUCCESS,
    data
  }),
  failure: (error): RefitLineServiceNoFailure => ({
    type: REFIT_LINE_SERVICE_NUMBERS_ERROR,
    error
  })
};